import React, {ForwardedRef, forwardRef} from 'react'

import {cn} from '@/src/shared/utils/twMerge'

const Header3 = forwardRef(
  (
    {children, className}: {children: React.ReactNode; className?: string},
    ref: ForwardedRef<HTMLParagraphElement>
  ) => {
    return (
      <h3
        ref={ref}
        className={cn(
          'lg:text-xl text-lg font-bold text-gray-900 leading-snug tracking-tight',
          className
        )}>
        {children}
      </h3>
    )
  }
)

Header3.displayName = 'Header3'

export default Header3
